import { styled } from '@mui/material/styles'
import { GridOverlay } from '@mui/x-data-grid'

const StyledGridOverlay = styled(GridOverlay)(() => ({
  flexDirection: 'column',
}))

export default StyledGridOverlay
